export const option = [{
        label: '姓名',
        prop: 'name',
        bind: "orderPersonalData.name",
        span: 6,
    },
    {
        label: "性别",
        prop: "gender",
        bind: 'orderPersonalData.gender',
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'sex'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 6
    },
    {
        label: '出生年月',
        prop: 'birthday',
        bind: 'orderPersonalData.birthday',
        span: 6
    },
    {
        label: '爱好',
        prop: 'hobby',
        bind: 'orderPersonalData.hobby',
        span: 6
    },
    {
        label: '籍贯',
        prop: 'nativePlace',
        bind: 'orderPersonalData.nativePlace',
        span: 6
    },
    {
        label: '电话',
        prop: 'contact',
        bind: 'orderPersonalData.contact',
        span: 6
    },
    {
        label: '健康情况',
        prop: 'healthyState',
        bind: 'orderPersonalData.healthyState',
        span: 6,
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'healthy'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        }
    },
    {
        label: '优先级',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'priority'
        },
        formatter: (row, value, label, column) => {
            return label
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        dataType: 'number',
        prop: "priority",
        bind: 'orderPersonalData.priority',
        span: 6,
    },
    {
        label: "身份证号",
        prop: "cardNo",
        bind: 'orderPersonalData.cardNo',
        span: 24
    },
    {
        label: "照片",
        prop: "photoUrl",
        bind: 'orderPersonalData.photoUrl',
        span: 8,
        formslot: true,
    },
    {
        labelWidth: 0,
        prop: 'info',
        span: 16,
        formslot: true
    },
    {
        label: '身高',
        prop: "height",
        bind: 'orderSocialSurvey.height',
        span: 8,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'height'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: '体重',
        prop: "weight",
        bind: 'orderSocialSurvey.weight',
        span: 8,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'weight'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: '性格',
        prop: "isCharacter",
        bind: 'orderSocialSurvey.isCharacter',
        span: 8,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'character'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    // {
    //     label: '户籍地址',
    //     prop: 'residenceAddress',
    //     bind: 'basisArchivePersonalData.residenceAddress',
    //     formslot: true,
    //     span: 24,
    //     row: true
    // },
    // {
    //     label: '现住地址',
    //     prop: 'actualResidentialAddress',
    //     bind: 'basisArchivePersonalData.actualResidentialAddress',
    //     span: 24,
    //     formslot: true,
    //     row: true
    // },
    {
        label: '就学情况',
        prop: 'studentStatus',
        bind: 'orderSocialSurvey.studentStatus',
        formslot: true,
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Academic_status'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true
    },
    {
        label: '学习经历',
        prop: 'studyExperience',
        bind: 'orderSocialSurvey.studyExperience',
        // type: 'textarea',
        span: 24,
        row: true
    },
    {
        label: '就业情况',
        prop: "employmentStatus",
        bind: 'orderSocialSurvey.employmentStatus',
        type: "select",
        dataType: "number",
        dicData: [{
            label: '已就业',
            value: 0
        }, {
            label: '未就业',
            value: 1
        }],
        formslot: true,
        span: 24,
        row: true
    },
    {
        label: '青少年类型',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Five-youth_types'
        },
        formatter: (row, value, label, column) => {
            return label
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        dataType: 'number',
        prop: "teenagersType",
        bind: 'orderPersonalData.teenagersType',
        span: 24,
        row:true
    },
    
    {
        label: '家庭类型',
        prop: 'householdType',
        bind: 'orderPersonalData.householdType',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'household_type'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 8,
    },
    {
        label: '家庭教养',
        prop: 'familyUpbringing',
        bind: 'orderPersonalData.familyUpbringing',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'parenting_pattern'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 8,
    },
    {
        label: '家庭经济',
        prop: 'familyEconomy',
        bind: 'orderPersonalData.familyEconomy',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'family-economic_status'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 8,

    }, {
        label: '家庭经济备注',
        prop: 'familyNote',
        bind: 'orderPersonalData.familyNote',
        span: 24,
        row: true
    },
    {
        label: "案件类型",
        prop: "crimeType",
        type: 'select',
        dataType: "string",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'crime_types'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 12,
    }, {
        label: "涉案时间",
        prop: "crimeTime",
        // type: "date",
        span: 12,
    }, {
        label: "涉案区域",
        prop: "regionCodeName",
        span: 12,
    }, {
        label: "涉案场所",
        prop: "placeTypeName",
        span: 12,
    },
    {
        label: "情况描述",
        prop: "crimeSituation",
        // type: 'textarea',
        span: 24,
        row: true,
        formslot: true
    },
    // {
    //     label: "案情概述",
    //     prop: "summarize",
    //     type: 'textarea',
    //     span: 24,
    //     row: true
    // },
    // {
    //     label: "案情详情",
    //     prop: "detail",
    //     type: 'textarea',
    //     span: 24,
    //     row: true
    // },
    // {
    //     label: '危险因素',
    //     prop: 'hazard',
    //     dataType: 'number',
    //     type: "select",
    //     dicUrl: "/api/blade-system/dict-biz/dictionary",
    //     dicQuery: {
    //         code: 'yes_no'
    //     },
    //     props: {
    //         label: "dictValue",
    //         value: "dictKey"
    //     },
    //     span: 24,
    //     row: true,
    //     formslot: true
    // },
    {
        label: '紧急服务',
        prop: 'emergencyServices',
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'yes_no'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true,
        formslot: true
    },
    {
        label: '曾使用相关服务记录',
        prop: 'isServiceSituation',
        bind: 'orderPersonalData.isServiceSituation',
        formslot: true,
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'yes_no'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true
    },
    {
        label: '现使用相关服务记录',
        prop: 'serviceSituationRecord',
        bind: 'orderPersonalData.serviceSituationRecord',
        formslot: true,
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'yes_no'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true
    }
]
export const peopleItem = [{
        label: '亲属关系',
        prop: 'orderKinshipList',
        span: 24,
        formslot: true,
        row: true
    },
    {
        label: '人际关系',
        prop: 'orderRelationList',
        span: 24,
        formslot: true,
        row: true
    }
]

export const followItem = [{
    label: '走访记录',
    prop: 'basisArchiveInterviewList',
    span: 24,
    formslot: true,
    row: true
}]

export const statusItem = [{
    label: '处理进度',
    prop: 'starOrderStatusList',
    span: 24,
    formslot: true,
    row: true,
    type: "select",
    dicData: [],
    props: {
        label: "dictValue",
        value: "dictKey"
    }
}]

export const initItem = [{
    label: '初始计划单',
    prop: 'initPlan',
    span: 24,
    formslot: true,
    row: true
}]


export const detailItem = [{
    label: '具体计划单',
    prop: 'detailInit',
    span: 24,
    formslot: true,
    row: true
}]

export const gjsfItem = [{
    label: '公检司法凭证',
    prop: 'gjsf',
    span: 24,
    formslot: true,
    row: true
}]

export const surveyItem = [{
        label: '调查方式',
        prop: "surveyMethod",
        bind: 'orderSocialSurvey.surveyMethod',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Investigation_method'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true
    },
    {
        label: '调查时间',
        prop: "surveyTime",
        bind: 'orderSocialSurvey.surveyTime',
        span: 24,
        row: true
    },
    {
        label: '调查主体',
        prop: "surveyMain",
        bind: 'orderSocialSurvey.surveyMain',
        span: 24,
        row: true
    },
    {
        label: '综合特质',
        prop: "comprehensive",
        bind: 'orderSocialSurvey.comprehensive',
        span: 24,
        row: true
    },
    {
        label: '情绪问题',
        prop: "mood",
        bind: 'orderSocialSurvey.mood',
        dicUrl: '/api/blade-system/dict-biz/dictionary',
        type: 'select',
        dicQuery: {
            code: 'emotional'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 12

    },
    {
        label: '家庭暴力问题',
        prop: 'domesticViolence',
        bind: 'orderSocialSurvey.domesticViolence',
        dicUrl: '/api/blade-system/dict-biz/dictionary',
        type: 'select',
        dicQuery: {
            code: 'family_violence'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 12,
        formslot: true

    },
    {
        label: '婚恋问题',
        prop: 'marriageProblems',
        bind: 'orderSocialSurvey.marriageProblems',
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary',
        dicQuery: {
            code: 'yes_no'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 12,
        formslot: true
    },

    {
        label: '经济援助',
        prop: 'financialAid',
        bind: 'orderSocialSurvey.financialAid',
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary',
        dicQuery: {
            code: 'yes_no'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 12,
        formslot: true
    },
    {
        label: '不良嗜好',
        prop: 'habits',
        bind: 'orderSocialSurvey.habits',
        type: "checkbox",
        dicUrl: '/api/blade-system/dict-biz/dictionary',
        dicQuery: {
            code: 'bad_hobby'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },

    },
    {
        label: "是否有纹身",
        prop: "isTattoo",
        bind: 'orderSocialSurvey.isTattoo',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'there_tattoo'
        },
        dataType: "number",
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否有手淫行为",
        prop: "isMasturbation",
        bind: 'orderSocialSurvey.isMasturbation',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dataType: "number",
        dicQuery: {
            code: 'Masturbation'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否有观看淫秽视频行为",
        prop: "isVideo",
        bind: 'orderSocialSurvey.isVideo',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Obscene_video'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否有打架经历",
        prop: "isFight",
        bind: 'orderSocialSurvey.isFight',
        type: "checkbox",
        dataType: "number",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Fighting_experience'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否经常出入娱乐场所",
        prop: "isEntertainment",
        bind: 'orderSocialSurvey.isEntertainment',
        type: "checkbox",
        dataType: "number",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Entertainment_place'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否夜不归宿行为",
        dataType: "number",
        prop: "isWantTo",
        bind: 'orderSocialSurvey.isWantTo',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Nocturnal_behavior'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "生活习惯",
        prop: "livingHabits",
        bind: 'orderSocialSurvey.livingHabits',
        // type: 'textarea'
    },
    {
        label: "作息时间",
        prop: "workTime",
        dataType: "number",
        bind: 'orderSocialSurvey.workTime',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Time_Table'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否有犯罪前科",
        dataType: "number",
        prop: "isCriminalRecord",
        bind: 'orderSocialSurvey.isCriminalRecord',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Criminal_record'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否喜欢网络游戏",
        dataType: "number",
        prop: "isOnlineGame",
        bind: 'orderSocialSurvey.isOnlineGame',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'network_game'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "在校处分情况",
        dataType: "number",
        prop: "isDisciplinary",
        bind: 'orderSocialSurvey.isDisciplinary',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'punishment'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "是否有旷课行为",
        dataType: "number",
        prop: "isTruancy",
        bind: 'orderSocialSurvey.isTruancy',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Absenteeism'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    },
    {
        label: "法律法规认知程度",
        dataType: "number",
        prop: "isRegulations",
        bind: 'orderSocialSurvey.isRegulations',
        type: "checkbox",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'Awareness-laws_regulations'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        }
    },
    {
        label: '需求跟进',
        prop: 'followUpType',
        bind: 'orderSocialSurvey.followUpType',
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'yes_no'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true,
        formslot: true
    },
    {
        label: '是否接受服务',
        prop: 'isService',
        bind: 'orderSocialSurvey.isService',
        dataType: 'number',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'yes_no'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        span: 24,
        row: true
    },
    {
        label: "处理记录",
        prop: "processingRecord",
        bind: 'orderSocialSurvey.processingRecord',
        // type: 'textarea',
        span: 24
    },
    {
        label: "服务情况",
        prop: "serviceSituation",
        bind: 'orderSocialSurvey.serviceSituation',
        // type: 'textarea',
        span: 24
    }
]

export const orderItem = [{
        label: '在社区或单位表现',
        prop: "performance",
        // type: 'textarea',
        span: 24,
        row: true
    },
    {
        label: '案主对今后发展期望',
        prop: "expectations",
        // type: 'textarea',
        span: 24,
        row: true
    },
    {
        label: '家庭对其将来回归社会的支持态度',
        prop: "support",
        // type: 'textarea',
        span: 24,
        row: true
    },
    {
        label: '经综合分析，提出如下意见',
        prop: "opinion",
        // type: 'textarea',
        span: 24,
        row: true
    }
]
